const rushOptionsList = (state = {}, action) => {
    switch (action.type) {
        case 'SET_LIST_RUSH_OPTIONS':
            return {
                ...state,
                rushList: action.payload
            };
        default:
            return state;
    }
};

export default rushOptionsList;
